import React, { useEffect, useState } from 'react';
import axios from 'axios';

function DashboardCard02({ stockSymbol }) {
  const [companyInfo, setCompanyInfo] = useState(null); // State to hold company information
  const [loading, setLoading] = useState(true); // Loading state

  // Fetch company information
  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        console.log(`Fetching company info for: ${stockSymbol}`); // Log the stock symbol
  
        const response = await axios.get(`https://investorverden.onrender.com/api/company?q=${stockSymbol}`);
        
        console.log('API response:', response.data); // Log the API response
  
        setCompanyInfo(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching company information:', error);
        setLoading(false);
      }
    };
  
    if (stockSymbol) {
      fetchCompanyInfo();
    } else {
      console.error('No stockSymbol provided');
    }
  }, [stockSymbol]); 

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-6 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
      <div className="px-5 pt-5">
        <header className="flex justify-between items-start mb-2">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
            {loading ? 'Loader...' : companyInfo ? companyInfo.Name : 'Intet firma fundet'}
          </h2>
        </header>
  
        {/* Company Information Section */}
        {!loading && companyInfo && (
          <div className="mb-4">
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Industri:</strong> {companyInfo.sectorDisp}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Beskrivelse:</strong> {companyInfo.longBusinessSummary}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardCard02;